import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {};

export const content: SxStyle = {
  '.MuiFormControl-root': {
    mb: 3,
  },
};

export const label: SxStyle = {
  fontSize: (p) => p.typography.caption.fontSize,
  fontWeight: (p) => p.typography.fontWeightBold,
};

export const input: SxStyle = {
  background: (p) => p.palette.grey[100],
  border: 'none',
  input: {
    p: 1,
  },
};
